// extracted by mini-css-extract-plugin
export default {"Milestone":"Milestone_Milestone__Pvurc","Title":"Milestone_Title__c8AYf","count":"Milestone_count__Ssnh1"};